import { useState } from "react";
import { motion } from "framer-motion";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { FadeUp, ChapterHeading } from "@/components/Reveal";

export const GallerySection = ({ gallery, name }) => {
  const [active, setActive] = useState(null);
  return (
    <section id="galerie" className="mx-auto max-w-7xl px-5 py-24 sm:px-8">
      <ChapterHeading num="03" title="Galerie" />
      <FadeUp className="mt-6">
        <h2 className="font-display text-3xl font-bold sm:text-5xl">
          Poze care <span className="italic text-red-400">miros a bine</span>
        </h2>
        <p className="mt-4 max-w-xl text-base text-stone-400 sm:text-lg">
          Direct de la {name} — fără filtre, fără rețuș, cu aburi.
        </p>
      </FadeUp>

      <div className="mt-12 grid grid-cols-2 gap-3 sm:gap-4 md:grid-cols-4" data-testid="gallery-grid">
        {gallery.map((g, i) => (
          <motion.button
            key={g.src}
            data-testid={`gallery-item-${i}`}
            onClick={() => setActive(g)}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.7, delay: (i % 4) * 0.08, ease: [0.22, 1, 0.36, 1] }}
            className={`group relative overflow-hidden rounded-2xl ${
              i % 7 === 0 ? "col-span-2 row-span-2 aspect-square" : "aspect-[4/3]"
            }`}
          >
            <img
              src={g.src}
              alt={g.caption}
              loading="lazy"
              className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#121110]/80 via-transparent to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
            <p className="absolute inset-x-0 bottom-0 translate-y-3 p-4 text-left text-xs font-medium text-stone-200 opacity-0 transition-all duration-500 group-hover:translate-y-0 group-hover:opacity-100 sm:text-sm">
              {g.caption}
            </p>
          </motion.button>
        ))}
      </div>

      <Dialog open={!!active} onOpenChange={() => setActive(null)}>
        <DialogContent data-testid="gallery-lightbox" className="max-w-4xl border-stone-800 bg-[#121110] p-2">
          {active && (
            <div>
              <img src={active.src} alt={active.caption} className="max-h-[75vh] w-full rounded-xl object-contain" />
              <p className="font-hand p-3 text-xl text-red-300">{active.caption}</p>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </section>
  );
};
